<template>
  <div>
    <div class="container-formulario-login">

      <img class="logo-modos-web" src="@/assets/modos_web_logo.png" alt="Logo da Claro">

      <div class="container-formulario">

        <form @submit.prevent="entrarNoSistema()">

          <v-row>

            <div class="hidden">
              <input type="password" />
            </div>

            <v-col cols="12">
              <SGPFormInputComponent type="text" v-model="dadosLogin.email" placeholder="Usuário" name="login"
                data-vv-as="Usuário" v-validate="'required|min:4'" :error="validationErrors.first('login')"
                autocomplete="off" outlined dense />
            </v-col>

            <v-col cols="12">
              <SGPFormInputComponent :type="mostrarSenha ? 'text' : 'password'" v-model="dadosLogin.password"
                placeholder="Senha" name="password" data-vv-as="Senha" v-validate="'required|min:6'"
                :error="validationErrors.first('password')" :appendIcon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
                @clickIconeEmit="mostrarSenha = !mostrarSenha" outlined dense />
            </v-col>

            <v-col cols="12">
              <v-btn type="submit" depressed color="primary" block rounded large :disabled="logando">
                <span v-if="!logando">Entrar no sistema</span>
                <v-progress-circular v-else indeterminate color="black" />
              </v-btn>
            </v-col>
          </v-row>
        </form>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.logo-modos-web {
  margin: 10px;
  margin-bottom: 20px;
}

</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: 'FormLoginComponent',

  data() {
    return {
      dadosLogin: {
        email: '',
        password: '',
        lembrar: false,
      },
      mostrarSenha: false,
    }
  },

  async created() {
    if (await this.usuarioEstaLogado()) {
      this.$router.push('/workflow/backlog')
    }
  },

  computed: {
    ...mapGetters('login', ['logando'])
  },

  methods: {
    ...mapActions('login', ['logarUsuario', 'deslogarUsuario', 'usuarioEstaLogado']),

    entrarNoSistema() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const loginResponse = await this.logarUsuario(this.dadosLogin)
          if (loginResponse.status === 200) {
            if (this.$route.query?.redirect_to) {
              this.$router.push(this.$route.query.redirect_to)
              return
            }
            this.$router.push('/selecionar-modulo')
          }
          return;
        }

        criarToast({
          tipo: 'error',
          mensagem: 'Por favor, verifique os campos e tente novamente!'
        })
      });
    }
  }
}
</script>
